$(document).ready(function () {

    var z=1040;
    $(document).on('hidden.bs.modal', '.modal', function (event) {
        if ($('.modal-backdrop').length > 0) {
            $('body').addClass('modal-open');
        }
        else {
            $('body').removeClass('modal-open');
        }
    });

    $(document).on('show.bs.modal', '.modal', function (event) {
        fixbs_modal_scroll_height();
        //z += 10;
       // $('.modal-backdrop').last().css('z-index', z-1);
       // $(this).css('z-index', z+1);
    });
});

function fixbs_modal_scroll_height() {
    var $modal=$('.modal'), modalBodyScrollHeight;
    $modal.unbind('scroll');
    var last_scroll = 0;
    $modal.scroll(function () {
       if( $('.modal-body')[0] ) {
           modalBodyScrollHeight = $('.modal-body')[0].scrollHeight;
           if (modalBodyScrollHeight === 0) {
               modalBodyScrollHeight = $('.modal:visible')[0].scrollHeight;
           }
       }

       if($('.modal-body')[0] == undefined || modalBodyScrollHeight === 0) {
           modalBodyScrollHeight = $('.modal:visible')[0].scrollHeight;
       }

       if (last_scroll != modalBodyScrollHeight  && modalBodyScrollHeight) {
            var $backdrop = $('.modal-backdrop', this);
            // remove old scroll bar
            $backdrop.css('height', $(window).height() + 'px');
            // set new scroll bar height
            $backdrop.css('height', this.scrollHeight + 'px');
            last_scroll = modalBodyScrollHeight ;
       }
    });
}
